import { Badge, TooltipRenderer, Text, Box } from 'braid-design-system';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

export const RelevantApplicationBadge = ({
  idSuffix,
  shouldShowTopPlacement,
}: {
  idSuffix: string;
  shouldShowTopPlacement: boolean;
}) => {
  const { t } = useTranslations(translations);
  return (
    <TooltipRenderer
      id={`relevant-badge-tooltip-${idSuffix}`}
      placement={shouldShowTopPlacement ? 'top' : 'bottom'}
      tooltip={
        <Text>
          {t(
            "This application is included in your Premium ad's relevant applications count",
          )}
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps} alignItems="center">
          <Badge tone="promote">{t('Relevant application')}</Badge>
        </Box>
      )}
    </TooltipRenderer>
  );
};
